import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont, pxToRem } from '@vfit/shared/themes';

export const MainContainer = styled.div`
  text-align: center;
  margin: 25px;

  @media (min-width: ${breakpoints.bigDesktop}) {
    .swiper-wrapper {
      justify-content: center;
    }
  }
`;

export const Title = styled.p`
  font-size: 28px;
  font-weight: 400;
  line-height: 36px;
`;

export const SmartCardUnit = styled.div`
  border: 1px solid #bebebe;
  border-radius: 20px;
  padding-inline: 24px;
  text-align: center;
`;

export const UnitTitle = styled.p`
  font-weight: 700;
  font-size: 20px;
  padding: 24px 0 16px;
  line-height: 0;
  /* line-height: 28px; */
  color: #e60000;

  /* margin: 25px; */
`;

export const UnitQuota = styled.p`
  font-weight: 700;
  font-size: 28px;
  line-height: 0;
  padding-bottom: 10px;
  @media (min-width: ${breakpoints.tablet}) {
    font-weight: 800;
  }
  /* line-height: 36px; */
`;

export const UnitLocation = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 0;
  padding-bottom: 10px;

  /* line-height: 28px; */
`;

export const UnitIcons = styled.div`
  padding-bottom: 24px;
  display: flex;
  justify-content: center;
  gap: 12px;
`;

export const UnitIcon = styled.div`
  width: 24px;
  height: 24px;
`;

